export const Features = () => {
  // AI-driven features list
  const features = [
    'enhanced staging visualization',
    'driven market trend analysis',
    'optimized furniture layouts',
    'driven customer support and recommendations',
    'informed furniture style suggestions',
  ];

  return (
    <section className="section-container">
      <div className="card flex flex-col gap-8 overflow-hidden">
        {/* Section header */}
        <div className="section-title relative z-10">
          <h2 className="section-title-prefix">our</h2>
          <div className="section-title-main">features</div>
        </div>

        {/* Features content */}
        <div className="relative z-10 flex flex-col items-center gap-10 md:flex-row md:gap-[150px]">
          {/* AI decoration */}
          <img
            className="relative hidden h-auto w-[120px] overflow-visible md:left-[-80px] md:block md:h-[499px] md:w-[179px]"
            src="a0.svg"
            alt="AI decoration"
            aria-hidden="true"
          />

          {/* Feature list */}
          <div className="flex flex-col items-center gap-4 md:flex-row md:gap-[35px]">
            <div
              className="text-center font-headline-headline-0-font-family text-5xl font-headline-headline-0-font-weight text-neutral-neutral-00 md:text-left md:text-headline-headline-0-font-size"
              style={{
                letterSpacing: '0.02em',
                WebkitTextStroke: '1px #3c3c3c',
              }}
            >
              AI-
            </div>

            {/* Features list */}
            <ul className="flex flex-col items-center gap-6 md:items-start md:gap-[60px]">
              {features.map((feature, idx) => (
                <li
                  key={idx}
                  className="text-center font-subtitle-subtitle-2-font-family text-sm font-subtitle-subtitle-2-font-weight uppercase leading-subtitle-subtitle-2-line-height text-primary-primary-30-main md:text-left md:text-subtitle-subtitle-2-font-size"
                >
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
